import { useState } from "react";
import { Link } from "react-router";
import {
  MailOutlined,
  PhoneOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { message } from 'antd';
import "../HomePage/HomePage.css"; // shared landing primitives (badge, btn, tokens)
import "./ContactPage.css";

const INFO = [
  { icon: <MailOutlined />, label: "General", value: "info@prenumbers.com" },
  { icon: <PhoneOutlined />, label: "Sales", value: "info@prenumbers.com" },
  { icon: <CalendarOutlined />, label: "Response time", value: "Within 1 business day" },
  { icon: <EnvironmentOutlined />, label: "HQ", value: "Greater New York City — remote" },
];

const TOPICS = [
  { key: "demo", label: "Request a demo" },
  { key: "pricing", label: "Pricing for a team" },
  { key: "partnership", label: "Partnership" },
  { key: "other", label: "Something else" },
];

const SUBMIT_LABEL = {
  demo: "Request a demo",
  pricing: "Get team pricing",
  partnership: "Start a partnership",
  other: "Send message",
};

function ContactPage() {
  const [topic, setTopic] = useState("demo");
  const [sent, setSent] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const sendMessage = async (formValues) => {
    messageApi.loading("Sending Message..", 0);
    
    let req = await fetch("/api/misc/contactEmail", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formValues)
    });
    let res = await req.json();

    messageApi.destroy();
    if (req.status == 200) {
      messageApi.success(res.message);
    } else {
      messageApi.error(res.error);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target); 
    const formValues = Object.fromEntries(formData); 

    await sendMessage(formValues);
    setSent(true);
  };

  return (
    <div className="home pn-landing pn-contact pn-bg-textured">
      {contextHolder}
      <section className="pn-ct-section">
        <div className="pn-container pn-ct-grid">
          {/* ===== LEFT ===== */}
          <div className="pn-ct-left">
            <span className="pn-badge">
              <i className="pn-badge-dot" /> Contact
            </span>
            <h1 className="pn-ct-title">Talk to the team behind the model.</h1>
            <p className="pn-ct-sub">
              Whether you want a demo, pricing for a portfolio, or help thinking about your next
              raise — we're here.
            </p>

            <div className="pn-ct-info">
              {INFO.map((i) => (
                <div className="pn-ct-info-card" key={i.label}>
                  <span className="pn-ct-info-icon">{i.icon}</span>
                  <div>
                    <span className="pn-ct-info-label">{i.label}</span>
                    <strong className="pn-ct-info-value">{i.value}</strong>
                  </div>
                </div>
              ))}
            </div>

            <div className="pn-ct-callout">
              <div className="pn-ct-callout-head">
                <i className="pn-badge-dot" /> Prefer a live walkthrough?
              </div>
              <p>
                A PreNumbers specialist will walk you through an example of an industry tailored
                (venture-scale) model — live.
              </p>
              <a href="#contact-form" className="pn-btn pn-btn-gold pn-ct-callout-btn">
                Request a demo <ArrowRightOutlined />
              </a>
            </div>
          </div>

          {/* ===== RIGHT (FORM) ===== */}
          <div className="pn-ct-form-card" id="contact-form">
            <h2 className="pn-ct-form-title">Send us a message</h2>
            <p className="pn-ct-form-sub">Typically responds within 1 business day.</p>

            {sent ? (
              <div className="pn-ct-sent">
                <h3>Thanks — message sent.</h3>
                <p>We'll be in touch within 1 business day.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="pn-ct-topics">
                  {TOPICS.map((t) => (
                    <button
                      type="button"
                      key={t.key}
                      className={`pn-ct-topic ${topic === t.key ? "active" : ""}`}
                      onClick={() => setTopic(t.key)}
                    >
                      <span className="pn-ct-radio" /> {t.label}
                    </button>
                  ))}
                </div>

                <div className="pn-ct-row">
                  <div className="pn-ct-field">
                    <label>First name</label>
                    <input className="pn-ct-input" type="text" name="firstName" required />
                  </div>
                  <div className="pn-ct-field">
                    <label>Last name</label>
                    <input className="pn-ct-input" type="text" name="lastName" required />
                  </div>
                </div>

                <div className="pn-ct-field">
                  <label>Work email</label>
                  <input className="pn-ct-input" type="email" name="email" required />
                </div>

                <div className="pn-ct-row">
                  <div className="pn-ct-field">
                    <label>Company</label>
                    <input className="pn-ct-input" type="text" name="company" />
                  </div>
                  <div className="pn-ct-field">
                    <label>Your role</label>
                    <input
                      className="pn-ct-input"
                      type="text"
                      name="role"
                      placeholder="Founder, CFO, etc."
                    />
                  </div>
                </div>

                <div className="pn-ct-field">
                  <label>You are a...</label>
                  <select className="pn-ct-input" name="persona" defaultValue="">
                    <option value="" disabled>
                      Select one...
                    </option>
                    <option>Founder / CEO</option>
                    <option>CFO / Finance lead</option>
                    <option>Fractional CFO / Consultant</option>
                    <option>VC / Investor</option>
                    <option>Venture studio / Accelerator</option>
                    <option>Other</option>
                  </select>
                </div>

                <div className="pn-ct-field">
                  <label>How can we help?</label>
                  <textarea
                    className="pn-ct-input pn-ct-textarea"
                    name="message"
                    rows={4}
                    placeholder="Tell us about your stage, team size, and what you're trying to accomplish."
                  />
                </div>

                <button type="submit" className="pn-btn pn-btn-gold pn-ct-submit">
                  {SUBMIT_LABEL[topic]}
                </button>
                <p className="pn-ct-privacy">
                  By submitting, you agree to our privacy policy. We never share your info.
                </p>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
